export default {
  navigationBarTitleText: '活动规则'
};
